import { Button, Divider, Modal, Radio, Typography } from "antd";
const { Title } = Typography;

export default function DecisionModal({
  isEntryModalOpen,
  setisEntryModalOpen,
  relationshipStatus,
  btnLoading,
  postJournal,
  onChange,
}) {
  return (
    <Modal
      className="create-diary-modal cm-modal "
      centered
      open={isEntryModalOpen}
      onOk={() => setisEntryModalOpen(false)}
      onCancel={() => setisEntryModalOpen(false)}
      closeIcon={<i className="icon-close"></i>}
      footer={[
        <Button
          disabled={!!!relationshipStatus}
          loading={btnLoading && isEntryModalOpen}
          key="submit"
          className="done-btn"
          type="primary"
          onClick={postJournal}
        >
          Done
        </Button>,
      ]}
    >
      <div className="common-modal-header">
        <i className="modal-icon icon-completd"></i>
        <div>
          <Title level={4}>Entry is Completed!</Title>
          <p>Where is the relationship headed?</p>
        </div>
      </div>
      <Divider />
      <Radio.Group
        className="archive-topic-btns"
        onChange={onChange}
        defaultValue="b"
        value={relationshipStatus}
        size="large"
        name="diaryRelationshipId"
      >
        <Radio.Button value="1" className="icon-btn">
          <i className="icon-happy smily-icon"></i>
          Issue Resolved
        </Radio.Button>
        <Radio.Button value="2" className="icon-btn">
          <i className="icon-laughing smily-icon"></i>Getting Better
        </Radio.Button>
        <Radio.Button value="3" className="icon-btn">
          <i className="icon-worse smily-icon"></i>Getting Worse
        </Radio.Button>
        <Radio.Button value="4" className="icon-btn">
          <i className="icon-confuse smily-icon"></i>Staying The Same
        </Radio.Button>
        <Radio.Button value="5" className="icon-btn">
          <i className="icon-sad smily-icon"></i>Relationship Ending
        </Radio.Button>
        <Radio.Button value="6" className="icon-btn">
          <i className="icon-angry smily-icon"></i>Agreed To Disagree
        </Radio.Button>
      </Radio.Group>
    </Modal>
  );
}
